import NotificationService from "@/services/notification.service";

export const notification = {
    namespaced: true, state: {count: 0, items: []}, actions: {
        markItemRead({commit}, id) {
            commit('markRead', id)
        },
        addItems({commit}, items, count = -1) {
            commit('addMoreItems', {items, count: (count < 0 ? items.length : count)});
        },
        clearItems({commit}) {
            commit('clear');
        },
        markAllAsRead({commit}) {
            commit('markRead')
        }
    },
    mutations: {
        markRead(state, id = null) {
            if (id) {
                state.count--;
                state.items = state.items.map(i => {
                    if (i.id == id) {
                        return {...i, read_at: (new Date()).toUTCString()}
                    }
                    return i;
                });
                NotificationService.readItem(id).catch(e => console.log(e));
            } else {
                state.count = 0;
                state.items = state.items.map(i => {
                    if (!i.read_at) {
                        return {...i, read_at: (new Date()).toUTCString()}
                    }
                    return i;
                });
                NotificationService.markAllAsRead().catch(e => console.log(e));
            }
        },
        addMoreItems(state, {items, count}) {
            state.count += Number(count);
            state.items = [...items, ...state.items];
        },
        clear(state) {
            state.count = 0;
            state.items = [];
        },
    }
}
